/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Name_FullInputs */



/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Team_Manager_Import_Name_FullInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_name_full = /** @type {((inputs?: Team_Manager_Import_Name_FullInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Name_FullInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom complet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständiger Name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome completo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Полное имя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("氏名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूरा नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome completo")
	return /** @type {LocalizedString} */ ("Full name")
});